import { render, staticRenderFns } from "./ResultPage.vue?vue&type=template&id=7ab8a49e&scoped=true"
import script from "./ResultPage.vue?vue&type=script&lang=js"
export * from "./ResultPage.vue?vue&type=script&lang=js"
import style0 from "./ResultPage.vue?vue&type=style&index=0&id=7ab8a49e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab8a49e",
  null
  
)

export default component.exports